import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { notifyError, notifyTopRight } from "../Common/Toaster";
import { approveRejectRequest } from "../../../services/UserServices/UserService";

const photoFeedbackOptions = [
  {
    en: "Your profile photo does not appear to represent you. Please re-upload an image of yourself. You can stay discreet with a blurred or cropped photo.",
    ch: "您的头像似乎不代表本人。请重新上传一张真实的个人照片。如需保持低调，可使用模糊或裁剪的照片。",
    zh: "您的頭像似乎不代表本人。請重新上傳一張真實的個人照片。如需保持低調，可使用模糊或裁剪的照片。",
    ms: "Gambar profil anda kelihatan tidak mewakili diri anda. Sila muat naik semula gambar sebenar anda. Anda boleh kekal privasi dengan gambar yang dikaburkan atau dipotong.",
    id: "Foto profil Anda tampaknya bukan milik Anda. Silakan unggah ulang foto asli Anda. Anda boleh tetap privat dengan foto buram atau yang dipotong sebagian.",
    vi: "Ảnh đại diện của bạn có vẻ không phải là bạn. Vui lòng tải lại ảnh thật của chính bạn. Bạn có thể giữ sự riêng tư bằng ảnh làm mờ hoặc cắt.",
    ko: "프로필 사진이 본인을 나타내지 않는 것 같습니다. 본인의 실제 사진을 다시 업로드해 주세요. 흐리거나 잘린 사진도 괜찮습니다.",
    ja: "プロフィール写真がご本人ではない可能性があります。ご自身の実際の写真を再アップロードしてください。ぼかしやトリミングされた写真でも問題ありません。",
    hi: "आपकी प्रोफ़ाइल फोटो शायद आपकी नहीं लगती। कृपया अपनी असली तस्वीर दोबारा अपलोड करें। आप ब्लर या क्रॉप की गई फोटो से भी गोपनीयता बनाए रख सकते हैं।"
  },
  {
    en: "Your photo doesn’t meet our current guidelines. To remain visible on Discover, please update it. You can stay discreet with a blurred or cropped photo.",
    ch: "您的照片不符合我们的社区规范。若想继续出现在发现页，请更新头像。如需保持低调，可使用模糊或裁剪的照片。",
    zh: "您的照片未符合我們目前的使用規範。若想繼續出現在探索頁面，請更新照片。如需保持低調，可使用模糊或裁剪的照片。",
    ms: "Gambar anda tidak menepati garis panduan kami. Untuk terus dipaparkan di Discover, sila kemas kini gambar anda. Anda boleh kekal privasi dengan gambar yang dikaburkan atau dipotong.",
    id: "Foto Anda tidak sesuai dengan pedoman kami. Untuk tetap tampil di Discover, harap perbarui foto Anda. Anda boleh tetap privat dengan foto buram atau yang dipotong sebagian.",
    vi: "Ảnh của bạn không đáp ứng quy chuẩn hiện tại của chúng tôi. Để tiếp tục hiển thị trên Khám phá, vui lòng cập nhật ảnh. Bạn có thể giữ sự riêng tư bằng ảnh làm mờ hoặc cắt.",
    ko: "사진이 현재 가이드라인에 부합하지 않습니다. 디스커버에 계속 표시되려면 사진을 업데이트해 주세요. 흐리거나 잘린 사진도 괜찮습니다.",
    ja: "写真が現在のガイドラインに適合していません。Discoverに表示され続けるには、写真を更新してください。ぼかしやトリミングされた写真でも問題ありません。",
    hi: "आपकी फोटो हमारे मौजूदा दिशानिर्देशों के अनुरूप नहीं है। Discover पर दिखने के लिए कृपया अपनी फोटो अपडेट करें। आप ब्लर या क्रॉप की गई फोटो से भी गोपनीयता बनाए रख सकते हैं।"
  },
   {
    en: "AI images are not allowed. Please upload a real photo of yourself. Cropped or blurred images are fine as long as they are genuine.",
    ch: "不允许使用 AI 图片。请上传真实的本人照片。裁剪或模糊的照片可以，但必须是真实的。",
    zh: "不允許使用 AI 圖片。請上傳真實的本人照片。裁剪或模糊的照片可以，但必須是真實的。",
    ms: "Imej AI tidak dibenarkan. Sila muat naik foto sebenar diri anda. Foto yang dipotong atau dikaburkan boleh digunakan selagi ia tulen.",
    id: "Gambar AI tidak diperbolehkan. Harap unggah foto asli diri Anda. Foto yang dipotong atau diburamkan diperbolehkan selama itu benar-benar asli.",
    vi: "Không được phép dùng hình ảnh AI. Vui lòng tải lên ảnh thật của bạn. Ảnh cắt hoặc làm mờ vẫn được chấp nhận miễn là là ảnh thật.",
    ko: "AI 이미지 사용은 허용되지 않습니다. 본인의 실제 사진을 업로드해 주세요. 잘라내거나 흐리게 한 사진도 괜찮지만 반드시 실제 사진이어야 합니다.",
    ja: "AI画像の使用はできません。ご本人の実際の写真をアップロードしてください。トリミングやぼかしを入れた写真でも構いませんが、必ず本物である必要があります。",
    hi: "एआई छवियों की अनुमति नहीं है। कृपया अपनी असली फोटो अपलोड करें। कटी हुई या धुंधली फोटो स्वीकार्य है, बशर्ते वह असली हो।"
  },
  {
    en: "Avatars, illustrations, or non-human images aren’t allowed. Please upload a real photo of yourself. You can stay discreet with a blurred or cropped photo.",
    ch: "不允许使用头像、插图或非真人图片。请上传一张真实的个人照片。如需保持低调，可使用模糊或裁剪的照片。",
    zh: "不允許使用虛擬頭像、插圖或非真人圖片。請上傳一張真實的個人照片。如需保持低調，可使用模糊或裁剪的照片。",
    ms: "Avatar, ilustrasi, atau gambar bukan manusia tidak dibenarkan. Sila muat naik gambar sebenar anda. Anda boleh kekal privasi dengan gambar yang dikaburkan atau dipotong.",
    id: "Avatar, ilustrasi, atau gambar non-manusia tidak diperbolehkan. Silakan unggah foto asli Anda. Anda boleh tetap privat dengan foto buram atau yang dipotong sebagian.",
    vi: "Ảnh đại diện, hình vẽ hoặc ảnh không phải người thật không được chấp nhận. Vui lòng tải lên ảnh thật của chính bạn. Bạn có thể giữ sự riêng tư bằng ảnh làm mờ hoặc cắt.",
    ko: "아바타, 일러스트, 또는 사람이 아닌 이미지는 허용되지 않습니다. 실제 본인의 사진을 업로드해 주세요. 흐리거나 잘린 사진도 괜찮습니다.",
    ja: "アバター、イラスト、人物以外の画像は使用できません。ご自身の実際の写真をアップロードしてください。ぼかしやトリミングされた写真でも問題ありません。",
    hi: "अवतार, चित्रण या गैर-मानव छवियाँ स्वीकार्य नहीं हैं। कृपया अपनी असली तस्वीर अपलोड करें। आप ब्लर या क्रॉप की गई फोटो से भी गोपनीयता बनाए रख सकते हैं।"
  },
  {
    en: "Profile photos should not include text, logos, or promotional content. Kindly upload an image of yourself. You can stay discreet with a blurred or cropped photo.",
    ch: "头像不可包含文字、标志或宣传内容。请上传一张您的个人照片。如需保持低调，可使用模糊或裁剪的照片。",
    zh: "頭像不可包含文字、標誌或廣告內容。請上傳您的個人照片。如需保持低調，可使用模糊或裁剪的照片。",
    ms: "Gambar profil tidak boleh mengandungi teks, logo, atau kandungan promosi. Sila muat naik gambar peribadi anda. Anda boleh kekal privasi dengan gambar yang dikaburkan atau dipotong.",
    id: "Foto profil tidak boleh mengandung teks, logo, atau konten promosi. Harap unggah gambar pribadi Anda. Anda boleh tetap privat dengan foto buram atau yang dipotong sebagian.",
    vi: "Ảnh đại diện không được chứa chữ, logo hoặc nội dung quảng bá. Vui lòng tải lên ảnh cá nhân của bạn. Bạn có thể giữ sự riêng tư bằng ảnh làm mờ hoặc cắt.",
    ko: "프로필 사진에 텍스트, 로고, 또는 홍보용 콘텐츠는 포함될 수 없습니다. 본인의 사진을 업로드해 주세요. 흐리거나 잘린 사진도 괜찮습니다.",
    ja: "プロフィール写真に文字、ロゴ、宣伝内容は含めないでください。ご自身の個人写真をアップロードしてください。ぼかしやトリミングされた写真でも問題ありません。",
    hi: "प्रोफ़ाइल फोटो में टेक्स्ट, लोगो या प्रचार सामग्री नहीं होनी चाहिए। कृपया अपनी व्यक्तिगत फोटो अपलोड करें। आप ब्लर या क्रॉप की गई फोटो से भी गोपनीयता बनाए रख सकते हैं।"
  },
  {
    en: "Your photo appears heavily filtered or digitally altered. Please upload a natural image that reflects you authentically.",
    ch: "您的照片看起来经过了过度滤镜或数码处理。请上传一张自然且真实反映您的照片。",
    zh: "您的照片看起來經過過度濾鏡或數位處理。請上傳一張自然、真實反映您的照片。",
    ms: "Gambar anda kelihatan terlalu ditapis atau diubah. Sila muat naik gambar semula jadi yang benar-benar mencerminkan diri anda.",
    id: "Foto Anda tampaknya terlalu difilter atau diedit secara digital. Harap unggah foto alami yang benar-benar mencerminkan diri Anda.",
    vi: "Ảnh của bạn có vẻ đã được chỉnh sửa hoặc áp dụng quá nhiều bộ lọc. Vui lòng tải lên ảnh tự nhiên và chân thật hơn.",
    ko: "사진이 과도하게 필터링되거나 디지털 편집된 것으로 보입니다. 자연스럽고 진정성 있는 사진을 업로드해 주세요.",
    ja: "写真に過度なフィルターやデジタル加工が見られます。自然で、あなたらしさが伝わる写真をご使用ください。",
    hi: "आपकी तस्वीर अत्यधिक फ़िल्टर या डिजिटल रूप से संपादित लग रही है। कृपया एक प्राकृतिक और वास्तविक फोटो अपलोड करें जो आपको सही रूप में दर्शाए।"
  },
  {
    en: "Your photo doesn’t clearly show your face. If you prefer to stay discreet, you may upload a blurred or partially cropped photo, as long as it’s genuinely you.",
    ch: "您的照片未清楚显示面部。如需保持低调，可上传模糊或部分裁剪的照片，但必须是您本人。",
    zh: "您的照片未清楚顯示面部。如需保持低調，您可使用模糊或部分裁剪的個人照片，但必須是您本人。",
    ms: "Wajah anda tidak kelihatan dengan jelas dalam gambar. Jika anda ingin kekal privasi, anda boleh muat naik gambar yang dikaburkan atau dipotong, asalkan ia adalah anda sendiri.",
    id: "Wajah Anda tidak terlihat jelas di foto. Jika Anda ingin tetap privat, Anda bisa unggah foto buram atau sebagian yang dipotong — asalkan itu adalah diri Anda sendiri.",
    vi: "Gương mặt bạn không hiển thị rõ trong ảnh. Nếu muốn giữ kín, bạn có thể dùng ảnh làm mờ hoặc cắt một phần — miễn là đó là chính bạn.",
    ko: "사진에서 얼굴이 명확하게 보이지 않습니다. 프라이버시를 원하신다면, 흐리거나 부분적으로 잘린 사진도 괜찮습니다 — 본인이어야 합니다.",
    ja: "顔がはっきり写っていないようです。プライバシーを保ちたい場合は、ぼかしたり部分的にトリミングした写真でも構いません — 本人であることが前提です。",
    hi: "आपकी फोटो में चेहरा स्पष्ट रूप से दिखाई नहीं दे रहा है। यदि आप गोपनीयता बनाए रखना चाहते हैं, तो ब्लर या आंशिक रूप से क्रॉप की गई फोटो भी मान्य है — जब तक वह वास्तव में आपकी हो।"
  },
  {
    en: "Please use a photo which best represents yourself in a luxury setting, or your account may be deactivated. You can stay discreet with a blurred or cropped photo.",
    ch: "请使用最能展现您个人风格的照片，否则您的帐户可能会被停用。如需保持低调，可使用模糊或裁剪的照片。",
    zh: "請使用最能代表您個人風格的照片，否則帳號可能會被停用。如需保持低調，可使用模糊或裁剪的照片。",
    ms: "Sila gunakan gambar yang paling mewakili diri anda secara autentik, atau akaun anda mungkin dinyahaktifkan. Anda boleh kekal privasi dengan gambar yang dikaburkan atau dipotong.",
    id: "Gunakan foto yang paling merepresentasikan diri Anda secara autentik, atau akun Anda mungkin akan dinonaktifkan. Anda boleh tetap privat dengan foto buram atau yang dipotong sebagian.",
    vi: "Hãy sử dụng ảnh phản ánh đúng bản thân một cách chân thực nhất, nếu không tài khoản của bạn có thể bị vô hiệu. Bạn có thể giữ sự riêng tư bằng ảnh làm mờ hoặc cắt.",
    ko: "본인을 가장 잘 표현하는 사진을 사용해 주세요. 그렇지 않으면 계정이 비활성화될 수 있습니다. 흐리거나 잘린 사진도 괜찮습니다.",
    ja: "ご自身を最もよく表す写真をご使用ください。そうでない場合、アカウントが停止される可能性があります。ぼかしやトリミングされた写真でも問題ありません。",
    hi: "कृपया ऐसी फोटो का उपयोग करें जो आपको सबसे अच्छी तरह से दर्शाती हो, अन्यथा आपका खाता निष्क्रिय किया जा सकता है। आप ब्लर या क्रॉप की गई फोटो से भी गोपनीयता बनाए रख सकते हैं।"
  },
  {
    en: "Final Notice: Your account will be permanently suspended if your profile photo continues to violate our guidelines. You can stay discreet with a blurred or cropped photo.",
    ch: "最后通知：若您的头像持续违反规范，帐户将被永久停用。如需保持低调，可使用模糊或裁剪的照片。",
    zh: "最後通知：若您的頭像持續違反規範，帳號將被永久停用。如需保持低調，可使用模糊或裁剪的照片。",
    ms: "Amaran akhir: Akaun anda akan digantung secara permanen jika gambar anda terus melanggar garis panduan kami. Anda boleh kekal privasi dengan gambar yang dikaburkan atau dipotong.",
    id: "Peringatan Terakhir: Akun Anda akan ditangguhkan secara permanen jika foto Anda terus melanggar pedoman kami. Anda boleh tetap privat dengan foto buram atau yang dipotong sebagian.",
    vi: "Cảnh báo cuối cùng: Tài khoản của bạn sẽ bị khóa vĩnh viễn nếu ảnh tiếp tục vi phạm quy định. Bạn có thể giữ sự riêng tư bằng ảnh làm mờ hoặc cắt.",
    ko: "최종 경고: 사진이 계속 가이드라인을 위반할 경우, 계정이 영구 정지될 수 있습니다. 흐리거나 잘린 사진도 괜찮습니다.",
    ja: "最終警告：ガイドライン違反の写真が続く場合、アカウントが永久に停止される可能性があります。ぼかしやトリミングされた写真でも問題ありません。",
    hi: "अंतिम चेतावनी: यदि आपकी प्रोफ़ाइल फोटो हमारी नीति का उल्लंघन करना जारी रखती है, तो आपका खाता स्थायी रूप से निलंबित किया जा सकता है। आप ब्लर या क्रॉप की गई फोटो से भी गोपनीयता बनाए रख सकते हैं।"
  }
];


const ReasonModal = ({ show, id, type, table, onHide }) => {
  const [reason, setReason] = useState("");
  const [errors, setErrors] = useState({ reason: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const selectedIndex = parseInt(reason, 10);
    const selected = photoFeedbackOptions[selectedIndex];

    const payloadValue = {
      message_en: selected?.en ?? "",
      message_ch: selected?.ch ?? "",
      message_zh: selected?.zh ?? "",
      message_ms: selected?.ms ?? "",
      message_id: selected?.id ?? "",
      message_vi: selected?.vi ?? "",
      message_ko: selected?.ko ?? "",
      message_ja: selected?.ja ?? "",
      message_hi: selected?.hi ?? "",
    };


    try {
      const payload = {
        userId: id,
        type: type,
        status: "rejected",
        reason: payloadValue.message_en,
        reason_ch: payloadValue.message_ch,
        reason_zh: payloadValue.message_zh,
        reason_ms: payloadValue.message_ms,
        reason_id: payloadValue.message_id,
        reason_vi: payloadValue.message_vi,
        reason_ko: payloadValue.message_ko,
        reason_ja: payloadValue.message_ja,
        reason_hi: payloadValue.message_hi,
      };
      await approveRejectRequest(payload);
      notifyTopRight("Rejected Successfully.");
      table();
      onHide();
      setReason("");
    } catch (error) {
      notifyError(error.response?.data?.message || "An error occurred");
      console.error("Error:", error.response || error);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <form onSubmit={handleSubmit}>
        <div className="modal-header">
          <h4 className="modal-title fs-20">Reason</h4>
        </div>
        <div className="modal-body">
          <div className="form-group mb-3">
            <label className="text-black font-w500">Reason(Optional) </label>
            {/* <textarea
              rows={5}
              className="form-control"
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                setErrors({ ...errors, reason: "" });
              }}
            /> */}
            <select
              className="form-control"
              rows={5}
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                setErrors({ ...errors, reason: "" });
              }}
            >
              <option value="">Select Reason</option>
              <option value={"-"}>-</option>
              {photoFeedbackOptions.map((option, index) => (
                <option key={index} value={index}>
                  {option.en}
                </option>
              ))}
            </select>
            {errors.reason && (
              <div className="text-danger fs-12">{errors.reason}</div>
            )}
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" onClick={onHide} className="btn btn-danger">
            <i className="flaticon-delete-1"></i> Cancel
          </button>
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default ReasonModal;
